import { render, staticRenderFns } from "./DocumentationInput.vue?vue&type=template&id=5624f262&"
import script from "./DocumentationInput.vue?vue&type=script&lang=ts&"
export * from "./DocumentationInput.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports